import type { i18n as I18nInstance, TFunction } from "i18next";

import { resolveCountPhrase } from "@/lib/i18n/resolveCountPhrase";

const TOTAL_ACTIVE_FILTER_STEM =
  "table.activeFilters.filtersBarTotalActiveFilterCount";
const HIDDEN_PAREN_STEM = "table.activeFilters.filtersBarHiddenParenCount";

type I18nForCountPhrase = Pick<I18nInstance, "exists" | "language">;

/**
 * Label for committed active filters — same wording as `DataTableActiveFiltersBar`
 * (`filtersBar*` keys): running total plus optional "(N on hidden columns)" when applicable.
 */
export const buildActiveFiltersBarCountLabel = ({
  t,
  i18n,
  totalCommittedFilterCount,
  hiddenCommittedFilterCount,
}: {
  t: TFunction;
  i18n: I18nForCountPhrase;
  totalCommittedFilterCount: number;
  hiddenCommittedFilterCount: number;
}): string => {
  if (totalCommittedFilterCount === 0) {
    return "";
  }
  const main = resolveCountPhrase(
    t,
    i18n,
    totalCommittedFilterCount,
    TOTAL_ACTIVE_FILTER_STEM,
  );
  if (hiddenCommittedFilterCount === 0) {
    return main;
  }
  return `${main}\u00A0${resolveCountPhrase(t, i18n, hiddenCommittedFilterCount, HIDDEN_PAREN_STEM)}`;
};
